<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<p class="dedi">For Michel</p>
<p class="dedi1">I love the gypsy soul in you and the joys and sorrows of your changing face.</p>
<a id="page_viii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Dedication.vue?6a53265c